import * as React from 'react'
import { CheckCircle } from 'react-feather'

import { Strong, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-BACKGROUND-CHECK`

interface IProps {
  licenseNumber: string | null
  licenseStatus: string | null
}

export default function BackgroundCheck(props: IProps) {
  const { licenseNumber, licenseStatus } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  if (licenseNumber === null || licenseStatus === null) return null

  return (
    <Bullet icon={<CheckCircle />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>{licenseStatus ? t(`${PRE}-YES`) : t(`${PRE}-NO`)}</Text>
    </Bullet>
  )
}
